import { Link as GastbyLink } from 'gatsby';
import React from 'react';

function Link(props) {
  return /*#__PURE__*/React.createElement(GastbyLink, props);
}

export default Link;